module.exports = __webpack_public_path__ + "static/img/gzh.da897bd.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/gzh.png
// module id = Y90N
// module chunks = 1